import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <p class="mb-3 bold text-center">Madagaskar'</p>

    <div class="poem">
      <p class="poem-block mb-3">
        Nokte marŝas ni, horizont’ griziĝas pale, <br/>
        Aperos baldaŭ suno de l’ montar’. <br/>
        ‘U singard’, amik’: sin preparis por batalo <br/>
        Aborigenoj de Madagaskar’!
      </p>

      <p class="poem-block mb-3">
        Sub la Suda Kruc’ vi memoras ruĝajn lipojn <br/>
        Kaj kison, aĉetitan por dolar’. <br/>
        ‘U singard’, amik’: ĉi-karesoj estas ĉipaj, <br/>
        Vi ne ekscitu koron pro inar’.
      </p>

      <p class="poem-block mb-3">
        Se renkontos vin via mort’ post oceano, <br/>
        Akceptu ĝin sen penoj, kun honor’. <br/>
        ‘U singard’, amik’: firme tenu en la mano <br/>
        La karabenon dum la lasta hor’.
      </p>

      <p class="poem-block mb-3">
        Nokte marŝas ni, horizont’ griziĝas pale, <br/>
        Aperos baldaŭ suno de l’ montar’. <br/>
        ‘U singard’, amik’: sin preparis por batalo <br/>
        Aborigenoj de Madagaskar’!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Jurij Vizbor'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['wkCa_aHTg1o'],
    itemTranslator: translator.esp
  }
}

export default item;